import React, {ReactNode} from "react";
import {Accordion, AccordionTab} from "primereact/accordion";
import {CertificateEntry} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import MessageBox from "./MessageBox";
import {MessageType} from "../log/MessageInterface";
import {I18nGlobals} from "../translation/i18nInterface";
import {KeystoreEntry} from "./KeystoreEntry";
import FileSizeUnit from "../units/FileSizeUnit";
import Translate from "../translation/Translate";
import FunctionHelper from "../helper/FunctionHelper";
import PortalPureComponent from "./PortalPureComponent";

interface KeystoreViewerProperties extends I18nGlobals {
	certificates?: Array<CertificateEntry>;
}

export class KeystoreViewer extends PortalPureComponent<KeystoreViewerProperties, any> {
	private renderError(exception: any): ReactNode {
		let codes: string = "";
		if (FunctionHelper.exists(exception.code)) {
			codes += "(errorcode: " + exception.code;

			if (FunctionHelper.exists(exception.exitCode)) {
				codes += ", exitcode: " + exception.exitCode;
			}

			codes += ")";
		}

		return (
			<MessageBox {...this.props} type={MessageType.DANGER} closeable={false}
						stacktrace={
							<>
								<p>{exception.message} {codes}</p>
								<pre>{exception.stack}</pre>
							</>
						}>
				{exception.message}
			</MessageBox>
		)
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		let certificates: Array<CertificateEntry> = FunctionHelper.applyValue(this.props.certificates, []);
		let certificateElements: Array<ReactNode> = [];

		for (let [key, certificate] of certificates.entries()) {
			let x509Certificate: x509.X509Certificate;

			try {
				x509Certificate = new x509.X509Certificate(certificate.certificate);

				certificateElements.push(
					<AccordionTab key={key} headerTemplate={
						<>
							<span className="icon icon-key tooltip" style={{marginRight: "5px"}}
								  data-pr-tooltip={Translate.value("control.keystore_viewer.private_key")}/>
							<span className="content tooltip" data-pr-tooltip={certificate.aliasName}>
								{certificate.aliasName}
							</span>
							<span className="algorithm tooltip"
								  data-pr-tooltip={x509Certificate.signatureAlgorithm.name}>
								{x509Certificate.signatureAlgorithm.name}
							</span>
							{FunctionHelper.exists(x509Certificate.publicKey.algorithm.modulusLength) &&
								<span className="key-length tooltip"
									  data-pr-tooltip={
										  x509Certificate.publicKey.algorithm.modulusLength + " " + FileSizeUnit.BIT
									  }>
									{x509Certificate.publicKey.algorithm.modulusLength + " " + FileSizeUnit.BIT}
								</span>
							}
						</>
					}>
						<KeystoreEntry {...this.props} certificate={certificate}/>
					</AccordionTab>
				);
			} catch (exception: any) {
				certificateElements.push(
					<AccordionTab key={key} headerTemplate={
						<span className="content">
							 <Translate {...this.props} data="control.keystore_viewer.invalid"/>
						</span>
					}>
						{this.renderError(exception)}
					</AccordionTab>
				);
			}
		}

		return (
			<>
				<div className="keystore-viewer">
					<div className="body">
						{certificates.length > 0 ?
							<Accordion activeIndex={0}>{certificateElements}</Accordion> :
							<p className="no-results">
								<Translate {...this.props} data="keystore.empty" namespace="dialog"/>
							</p>
						}
					</div>
				</div>
			</>
		);
	}
}